import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Profile = () => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/signin');
    } else {
      navigate('/account/profile-details');
    }
  }, [isLoggedIn, navigate]);

  return null;
};

export default Profile;